module.exports = __webpack_public_path__ + "static/media/Kuva_4_3.ed60f8aa.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Kuva_4_3.png
// module id = 1399
// module chunks = 0